export default __webpack_public_path__ + "static/blog-2-37b76caf0be04efdd2ad0f787072b529.jpg";